module.exports = __webpack_public_path__ + "static/media/winno.529e744b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingFlow/assets/winno.gif
// module id = 932
// module chunks = 0